import axios from "axios";
import ConnUrls from '../Connections/ConnectURL';


const getMyCredits = async (token, excludeOrderNum) => {
    let dFromF = await axios.get(ConnUrls.ApiUrl + "credits/getMyCredits", { params: { token, excludeOrderNum } });
    return dFromF.data;
};

const getMyCreditsLog = async (token) => {
    let dFromF = await axios.get(ConnUrls.ApiUrl + "credits/getMyCreditsLog", { params: { token } });
    return dFromF.data;
};

export default { getMyCredits, getMyCreditsLog };
